import React, { useMemo } from 'react';

/**
 * EmailQuickFilters — filter pills (Tous/Non lus/Rattachés/Suivis/PJ/Cette semaine)
 * + Focus mode toggle. Rendered just below the toolbar above the threads list.
 *
 * Pure presentational. Owned state lives in `pages/Email.jsx`.
 * Extracted from the monolith (Wave 1u3 refactor step 3).
 */
export default function EmailQuickFilters({
  threads = [],
  quickFilter,
  onChange,
  focusMode,
  onToggleFocus,
}) {
  const tabs = useMemo(() => {
    const weekMs = 7 * 24 * 3600 * 1000;
    const now = Date.now();
    return [
      { id: 'all',         label: 'Tous',          count: threads.length },
      { id: 'unread',      label: 'Non lus',       count: threads.filter((t) => t.unread).length },
      { id: 'crm',         label: 'Rattachés',     count: threads.filter((t) => t.crm_match).length },
      { id: 'starred',     label: 'Suivis',        count: threads.filter((t) => t.starred).length },
      { id: 'attachments', label: 'Avec PJ',       count: threads.filter((t) => t.has_attachments).length },
      { id: 'week',        label: 'Cette semaine', count: threads.filter((t) => (now - (t.date_ms || 0)) <= weekMs).length },
    ];
  }, [threads]);

  return (
    <div
      className="px-3 py-2 border-b border-[#EFF0F6] flex items-center gap-1.5 overflow-x-auto"
      data-testid="email-quick-filters"
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange?.(tab.id)}
          data-testid={`email-quickfilter-${tab.id}`}
          className={`px-2.5 py-1 rounded-full text-[11px] font-semibold whitespace-nowrap transition ${
            quickFilter === tab.id
              ? 'bg-[#4F46E5] text-white'
              : 'bg-[#F6F7FB] text-[#6B6C85] hover:bg-[#EEF2FF] hover:text-[#4F46E5]'
          }`}
        >
          {tab.label}
          {tab.count > 0 && <span className="ml-1 opacity-80">{tab.count}</span>}
        </button>
      ))}
      <button
        onClick={onToggleFocus}
        data-testid="email-focus-toggle"
        title="Mode focus : non lus + rattachés CRM uniquement"
        className={`ml-1 px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap border ${
          focusMode
            ? 'bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]'
            : 'bg-white text-[#8E8FA5] border-[#EFF0F6] hover:border-[#FDE68A]'
        }`}
      >
        ★ Focus
      </button>
    </div>
  );
}
